module.exports = __webpack_public_path__ + "488d5cc145299ba07b75495100419ee6.ttf";


//////////////////
// WEBPACK FOOTER
// ./~/clarity-ui/dist/fonts/open-sans-regular.ttf
// module id = 1575
// module chunks = 0